import { Pressable, View } from 'react-native';
import { router } from 'expo-router';
import { ArrowLeft } from 'lucide-react-native';
import { colors } from '@hogar/shared';
import { Txt } from './ui';

export function BackHeader({ title, subtitle, fallback = '/' }: { title: string; subtitle?: string; fallback?: string }) {
  return (
    <View style={{ marginBottom: 16 }}>
      <Pressable
        onPress={() => (router.canGoBack() ? router.back() : router.replace(fallback as never))}
        hitSlop={12}
        style={{ width: 44, height: 44, justifyContent: 'center', marginLeft: -6 }}
        accessibilityLabel="Back"
      >
        <ArrowLeft size={24} color={colors.text} />
      </Pressable>
      <Txt weight="semibold" size={26}>
        {title}
      </Txt>
      {subtitle ? (
        <Txt color={colors.textMuted} size={15} style={{ marginTop: 2 }}>
          {subtitle}
        </Txt>
      ) : null}
    </View>
  );
}
